import { useQuery } from "react-query";

import { reportingService } from "services";

type UseAgentOfficeReportsListProps = {
	paidMonth: Date | string;
	paidYear: Date | string;
	fetchData: { page: number; filters: any; sortBy: { [key: string]: any } };
};

const useAgentOfficeReportsListQuery = ({
	fetchData,
	paidMonth,
	paidYear,
}: UseAgentOfficeReportsListProps) => {
	const { page, filters, sortBy } = fetchData;

	const fetchList = () =>
		reportingService.getAgentOfficeReportsList({
			paidMonth,
			paidYear,
			page,
			filters,
			sortBy,
		});

	const queryResult = useQuery(
		["agentOfficeReportsList", paidMonth, paidYear, page, filters, sortBy],
		fetchList,
		{
			retry: 0,
			cacheTime: 0,
		},
	);

	return queryResult;
};

export default useAgentOfficeReportsListQuery;
